<template>
  <div class="registration login-page" :class="{'no-header': !hasHeader}">
    <div class="title-section" v-if="$props.pageTitle || $props.pageSubtitle">
      <h1 class="page-title" v-if="$props.pageTitle">{{ $props.pageTitle }}</h1>
      <p class="page-subtitle" v-if="$props.pageSubtitle">{{ $props.pageSubtitle }}</p>
    </div>
    <login-form/>
  </div>
</template>

<script>

import LoginForm from '@/components/login/login-form'
import { lsGet, lsRemove } from '@/utils/localStorageController'
import { LOGIN_COOKIE_NAME, SECURITY_COOKIE_NAME } from '@/services/securityCookieHandler'
import { addDataLayerEvent } from '@/services/dataLayer'

export default {
  name: 'page-user-login',
  components: { LoginForm },
  props: {
    pageTitle: String,
    pageSubtitle: String,
    hasHeader: {
      type: Boolean,
      default: true
    }
  },
  mounted () {
    if (lsGet('sc_emailVerification')) {
      this.toast('success', {
        title: this.$t('toastMessages.successEmailVerificationTitle'),
        message: this.$t('toastMessages.successEmailVerificationMessage')
      })
      lsRemove('sc_emailVerification')
    }
    if (lsGet('sc_changeEmailVerification')) {
      this.toast('success', {
        message: this.$t('toastMessages.successChangeEmailAddressMessage')
      })
      lsRemove('sc_changeEmailVerification')
    }
    this.$cookies.remove(LOGIN_COOKIE_NAME)
    this.$cookies.remove(SECURITY_COOKIE_NAME)

    addDataLayerEvent({
      event: 'screen',
      name: 'sign_in'
    })
  }
}
</script>
<style scoped lang="scss">
.no-header {
  min-height: 100vh;
}
</style>
